import React from 'react';

export function CupIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.125 13.75V15.5V13.75Z" fill="white" />
      <path d="M10.125 13.75V15.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.9585 18.332H14.2918V17.4987C14.2918 16.582 13.5418 15.832 12.6252 15.832H7.62516C6.7085 15.832 5.9585 16.582 5.9585 17.4987V18.332V18.332Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M5.125 18.332H15.125" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.99984 13.3346C6.77484 13.3346 4.1665 10.7263 4.1665 7.5013V5.0013C4.1665 3.15964 5.65817 1.66797 7.49984 1.66797H12.4998C14.3415 1.66797 15.8332 3.15964 15.8332 5.0013V7.5013C15.8332 10.7263 13.2248 13.3346 9.99984 13.3346Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.55853 9.70833C3.93353 9.50833 3.38353 9.14167 2.9502 8.70833C2.2002 7.875 1.7002 6.875 1.7002 5.70833C1.7002 4.54167 2.61686 3.625 3.78353 3.625H4.3252C4.15853 4.00833 4.0752 4.43333 4.0752 4.875V7.375C4.0752 8.20833 4.2502 8.99167 4.55853 9.70833Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4419 9.70833C16.0669 9.50833 16.6169 9.14167 17.0502 8.70833C17.8002 7.875 18.3002 6.875 18.3002 5.70833C18.3002 4.54167 17.3836 3.625 16.2169 3.625H15.6752C15.8419 4.00833 15.9252 4.43333 15.9252 4.875V7.375C15.9252 8.20833 15.7502 8.99167 15.4419 9.70833Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
